import React, { useState } from "react";
import { useRouter } from "next/router";
import { JBOnlineFormWrapper } from "./components/jointBidders/JBOnlineFormWrapper";
export default function AddJointBidderWrapper() {
  const router = useRouter();
  const { bidder_type, id, bidders_count } = router.query as {
    bidder_type?: string;
    id?: string;
    bidders_count?: string;
  };
  console.log({ bidder_type, bidders_count, id });
  if (bidder_type !== "joint" || !bidders_count || Number(bidders_count) < 2) {
    console.log("redirecting");
    // router.replace("/");
  }
  const [showJBListModal, setShowJBListModal] = useState(true);
  return (
    <div className="w-full bg-white px-5 pb-4">
      <JBOnlineFormWrapper />
    </div>
  );
}
